export default __webpack_public_path__ + "static/media/banner_m.1baecddc.png";